import * as loadQueueHelper from '../../../../shared/js/document/load-queue'
import storage from '../../../../shared/js/document/web-storage'

loadQueueHelper.add(function () {
  this.cookie = storage.cookie
  this.cookie.delete('cookielawlevel')
})
